import React from 'react';
import { theme } from '../../theme';

// Sticky bottom action bar — mirrors Swipe's create-invoice page where the
// Save buttons stay glued to the viewport bottom even as the form scrolls.
// Useful on long forms where the user shouldn't have to scroll back to top
// just to save.
//
// Props:
//   left   optional ReactNode rendered left (e.g. "Items: 3, Qty: 5")
//   right  the primary action buttons
export default function StickyBottomBar({ left, right }) {
  return (
    <div style={{
      position: 'sticky', bottom: 0, zIndex: 50,
      backgroundColor: theme.surface,
      borderTop: `1px solid ${theme.border}`,
      boxShadow: theme.stickyShadowTop,
      padding: '12px 18px',
      marginTop: '14px',
      borderRadius: '12px 12px 0 0',
      display: 'flex', alignItems: 'center', gap: '14px',
    }}>
      {left && <div style={{ flex: 1, fontSize: '0.85rem', color: theme.textMuted }}>{left}</div>}
      {!left && <div style={{ flex: 1 }}/>}
      {right && <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>{right}</div>}
    </div>
  );
}
